import { type ImageElementType } from "@/gc-sanity-types"
import type { ColorValue } from "@sanity/color-input"
import { clsx } from "@/src/utils/clsx"
import Image from "next/image"

export type BadgeType = "information" | "sale"
export type BadgeSize = "small" | "medium"

export interface GCBadgeBadgeProps {
    badgeText?: string
    badgeImage?: ImageElementType
    backgroundColor?: ColorValue
    badgeType?: BadgeType
    badgeSize?: BadgeSize
    className?: string
    textColor?: string
}

export default function GCBadge({
    badgeText,
    badgeImage,
    backgroundColor: defaultBackgroundColor,
    badgeType = "information",
    className,
    textColor: defaultTextColor = "text-main-black"
}: GCBadgeBadgeProps) {
    const hexColor = defaultBackgroundColor?.hex || undefined
    const typeColor = badgeType === "sale" ? "bg-sale-yellow" : "bg-black"
    const tailwindBackgroundColor = defaultBackgroundColor ? "" : typeColor

    const textColor = defaultTextColor
        ? defaultTextColor
        : badgeType === "sale"
          ? "text-main-black"
          : "text-main-white"

    return (
        <>
            {badgeText && (
                <div
                    className={clsx(
                        "flex",
                        "px-4 pb-4 pt-5 sm:px-8 sm:pb-4 sm:pt-6",
                        tailwindBackgroundColor,
                        className
                    )}
                    style={{ backgroundColor: hexColor }}
                >
                    <p
                        className={clsx(
                            textColor,
                            "Trim_Mono_POC_Text_10_130_3_400_uppercase sm:Trim_Mono_POC_Text_12_130_6_400_uppercase"
                        )}
                    >
                        {badgeText}
                    </p>
                </div>
            )}
            {badgeImage && badgeImage?.image && (
                <div
                    className={clsx(
                        "h-[26px] w-[46px]",
                        "h-[24px] w-[44px] sm:h-[40px] sm:w-[64px]",
                        className
                    )}
                >
                    <Image
                        src={badgeImage.image.asset.url ?? ""}
                        alt={badgeImage.image.alt || "Badge Image"}
                        layout="fill"
                        className="object-cover"
                    />
                </div>
            )}
        </>
    )
}
